import { useTranslation } from "react-i18next";
import { useHasRole } from "../auth";

/** Masks all but the last `keep` characters. */
export function mask(value: string, keep = 2): string {
  const k = Math.max(0, Math.floor(keep));
  if (value.length <= k) return "•".repeat(value.length);
  // `slice(-0)` would return the whole string, so keep = 0 must be special-cased.
  return "•".repeat(Math.min(8, value.length - k)) + (k > 0 ? value.slice(-k) : "");
}

/** PII is shown only to `pii-reader`; everyone else sees a masked value (server masks too). */
export function MaskedValue({ value, keep = 2 }: { value: string | null | undefined; keep?: number }) {
  const canRead = useHasRole({ anyOf: ["pii-reader"] });
  const { t } = useTranslation("common");
  if (!value) return null;
  if (canRead) return <span>{value}</span>;
  return (
    <span aria-label={t("pii.masked")} title={t("pii.masked")} dir="ltr">
      {mask(value, keep)}
    </span>
  );
}
